import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Notification";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export default {
  GetAll,
  GetById,
};
